import { render, staticRenderFns } from "./BottomButton.vue?vue&type=template&id=4fa99f36&scoped=true&"
import script from "./BottomButton.vue?vue&type=script&lang=ts&"
export * from "./BottomButton.vue?vue&type=script&lang=ts&"
import style0 from "./BottomButton.vue?vue&type=style&index=0&id=4fa99f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa99f36",
  null
  
)

export default component.exports